module.exports = __webpack_public_path__ + "media/evolve/assets/icons/planned/chevron-right-double-small-8831006e6c1852b2d728b72b2cf57ad3.svg";